<template>
  <div v-loading="loading" class="brand-card">
    <div>
      <p class="header">Company Details</p>
      <p class="subheader mt-1">Keep your company details up to date.</p>
    </div>

    <div v-if="false">
      <p class="text-sm font-bold">Logo</p>
      <img
        class="h-24 mt-2"
        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
        alt=""
      />
      <el-button class="mt-4">Upload Photo</el-button>
    </div>

    <div class="flex flex-col">
      <div class="-mx-3 md:flex mt-6 mb-6">
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Company Name</p>
          <el-input v-model="org.name" type="text"></el-input>
        </div>
        <div class="md:w-1/2 px-3">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Industry</p>
          <el-input v-model="org.industry" type="text"></el-input>
        </div>
      </div>
      <div class="-mx-3 md:flex mb-6">
        <div v-if="false" class="md:w-1/2 px-3 mb-6 md:mb-0">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Company Phone</p>
          <el-input v-model="org.phone" type="text"></el-input>
        </div>
        <div class="md:w-1/2 px-3">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Churn Goal</p>
          <el-input v-model="org.churnGoal" type="number"></el-input>
        </div>
      </div>
    </div>

    <div v-if="false" class="flex flex-col">
      <p class="text-lg font-bold">Company Address</p>
      <p class="text-sm text-gray-600 mt-1 mb-6">For invoicing. This is optional.</p>
      <div class="-mx-3 md:flex mb-6">
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Address Line 1</p>
          <el-input v-model="org.address.line1" type="text"></el-input>
        </div>
        <div class="md:w-1/2 px-3">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Address Line 2</p>
          <el-input v-model="org.address.line2" type="text"></el-input>
        </div>
      </div>
      <div class="-mx-3 md:flex mb-6">
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">City</p>
          <el-input v-model="org.address.city" type="text"></el-input>
        </div>
        <div class="md:w-1/2 px-3">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">State or Province</p>
          <el-input v-model="org.address.stateProvince" type="text"></el-input>
        </div>
      </div>
      <div class="-mx-3 md:flex mb-6">
        <div class="md:w-1/2 px-3 mb-6 md:mb-0">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">ZIP or Postal Code</p>
          <el-input v-model="org.address.zipPostal" type="text"></el-input>
        </div>
        <div class="md:w-1/2 px-3">
          <p class="tracking-wide text-gray-600 text-sm font-bold mb-2">Country</p>
          <el-input v-model="org.address.country" type="text"></el-input>
        </div>
      </div>
    </div>

    <div>
      <div class="flex justify-start flex-grow-0">
        <el-button @click="save" :loading="loading" type="primary">Save Settings</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrgService from '@/api/org.service';
import { SYNC_USER_RECORD } from '@/store/action-types';

export default {
  name: 'SettingsCompany',
  data() {
    return {
      org: {
        name: '',
        industry: '',
        churnGoal: '',
        phone: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          stateProvince: '',
          zipPostal: '',
          country: '',
        },
      },
      loading: true,
    };
  },
  async created() {
    // sync user org plan
    if (this.$store.state.org) {
      this.org = this.$store.state.org;
    }
    await this.$store.dispatch(SYNC_USER_RECORD);
    this.org = this.$store.state.org;
    this.loading = false;
  },
  methods: {
    async save() {
      this.loading = true;

      try {
        await OrgService.update(this.org._id, {
          name: this.org.name,
          industry: this.org.industry,
          phone: this.org.phone,
          churnGoal: this.org.churnGoal,
          address: this.org.address,
        });
        this.$notify({ title: 'Company Updated', type: 'success' });
      } catch (error) {
        this.$notify({ title: 'Update Failed', type: 'error' });
        console.log('Error', error);
      }

      this.loading = false;
    },
  },
};
</script>
